import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "rcornersgrey mx-auto vstack",
  style: {"width":"500px","overflow":"initial"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "nav nav-tabs nav-justified"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "actions w-100 mt-3 text-center hstack gap-2" }

import {computed, ref, watch} from "vue";
import {useOriStore} from "@/stores/oriStore";
import useValidation from "../Misc/validationUtils";
import SelectField from "../Misc/SelectField.vue";
import {SelectEntryType, SelectItem, SelectorMode} from "../../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'WebEntrySelectorLayout',
  props: {
    title: {},
    modes: {},
    showNav: { type: Boolean },
    error: {},
    agencies: {}
  },
  emits: ["oriChange", "submit", "modeChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
var oriStore = useOriStore();
const emits = __emit;
const {validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray} =
    useValidation();

const selectedOri = ref("");
const errorText = ref("");

if (props.error != "") {
    errorText.value = props.error;
}

const currentMode = ref(SelectEntryType.Add);
if (props.modes.length == 1) {
    currentMode.value = props.modes[0].type;
} else {
    props.modes.forEach((mode) => {
        if (mode?.isDefaultSelection) {
            currentMode.value = mode.type;
        }
    });
}
emits("modeChange", currentMode.value);

const subTitle = computed(() => {
    let subTitle = "";

    switch (currentMode.value) {
        case SelectEntryType.Add:
            subTitle = "Add";
            break;
        case SelectEntryType.Edit:
            subTitle = "Edit";
            break;
        case SelectEntryType.Delete:
            subTitle = "Delete";
            break;
        case SelectEntryType.Zero:
            subTitle = "Zero Report";
            break;
    }

    return subTitle;
});

function handleSubmitClick() {
    if (validate()) {
        emits("submit", selectedOri, currentMode.value);
    }
}

function handleNavChange(newMode: SelectEntryType) {
    currentMode.value = newMode;
    errorText.value = "";
    emits("modeChange", currentMode.value);
}

function validate(): boolean {
    let formValid = false;
    let form = document.getElementById("mainForm") as HTMLFormElement;

    if (form != null) {
        formValid = triggerValidation();

        if (formValid && form.classList.contains("was-validated")) {
            form.classList.remove("was-validated");
        }
    }

    return formValid;
}

watch(
    () => selectedOri.value,
    (newSelectedOri) => {
        oriStore.setSelectedOri(newSelectedOri);
        emits("oriChange", newSelectedOri);
    }
);

watch(
    () => props.error,
    (error) => {
        errorText.value = error;
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (!_ctx.showNav)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(subTitle.value), 1))
      : _createCommentVNode("", true),
    (_ctx.showNav)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["nav-link", {active: currentMode.value == mode.type, 'd-none': _ctx.modes.length == 1}]),
              "aria-current": "page",
              onClick: _withModifiers(($event: any) => (handleNavChange(mode.type)), ["prevent"])
            }, _toDisplayString(mode.label), 11, _hoisted_5))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{'border-top': !_ctx.showNav}, "border-start border-end border-bottom p-3"])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Agency:", -1)),
        _createVNode(SelectField, {
          modelValue: selectedOri.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOri).value = $event)),
          "select-items": _ctx.agencies,
          "is-horizontal": false,
          "is-required": true,
          ref: 
                        (el) => {
                            _unref(addValidatableComponent)(el);
                        }
                    
        }, null, 8, ["modelValue", "select-items"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
        return (_openBlock(), _createElementBlock("div", null, [
          _withDirectives(_createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, `extra-fields-${mode.type}`, {
              ref_for: true,
              ref: 
                            (el) => {
                                _unref(addValidatableComponent)(el);
                            }
                        
            })
          ], 512), [
            [_vShow, currentMode.value == mode.type]
          ])
        ]))
      }), 256)),
      _withDirectives(_createElementVNode("div", {
        class: "alert alert-danger mt-1",
        role: "alert"
      }, _toDisplayString(errorText.value), 513), [
        [_vShow, errorText.value != '']
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleSubmitClick()), ["prevent"]))
        }, " Submit ")
      ])
    ], 2)
  ]))
}
}

})